/* eslint-disable jsx-a11y/heading-has-content */
// src/pages/TrendingTopics.jsx

import React, { useState, useEffect } from "react";
import TrendingTopicsChart from "../components/trending/TrendingTopicsChart";
import TimeSelector from "../components/trending/TimeSelector";
import ClaimsContainer from "../components/trending/ClaimsContainer";
import PolicySupportChart from "../components/trending/PolicySupportChart";
import { fetchTrendingData } from "../api/trendingService";
import "../styles/trending/TrendingTopics.css";
import TwitterShareButton from '../components/TwitterShareButton';


const TrendingTopics = () => {
  const [trendingData, setTrendingData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [timeframe, setTimeframe] = useState("weekly");
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchTrendingData(timeframe);
        setTrendingData(data);
        console.log("Fetched data:", data);
        // Don't log trendingData here as it won't be updated yet
        setError(null);
      } catch (err) {
        setError("Failed to load trending data. Please try again later.");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [timeframe]);

  const handleTimeChange = (selectedTime) => {
    setTimeframe(selectedTime);
  };

  if (isLoading) {
    return <div className="loading-container">Loading trending topics...</div>;
  }

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  return (
    <div className="trending-page">
      <div className="content-container">
        <div className="page-header">
          <h1
            title="Trending Political Topics"
            subtitle="Discover what Australians are fact-checking and discussing this week"
          />
          <TimeSelector
            selectedTime={timeframe}
            onTimeChange={handleTimeChange}
          />
          
        </div>
        <TwitterShareButton 
        text="Check out the most popular search topics on this Fact Check Platform to avoid the pitfalls of Fake News!" 
        url="https://true-vote.pages.dev/topics" 
        hashtags={["truevote", "parliament", "SayNoToFakeNews"]} 
      />

        <section className="trending-topics-section">
          <div className="section-card">
            <h2 className="section-title">Most Searched Topics</h2>
            <TrendingTopicsChart topics={trendingData.topics} />
          </div>
        </section>

        <section className="trending-claims-section">
          <h2 className="section-title">Trending Fact-Checked Claims</h2>
          <ClaimsContainer claims={trendingData.claims} />
        </section>

        <section className="policy-support-section">
          <h2 className="section-title">Policy Support Analysis</h2>
          <div className="section-card">
            <h3 className="subsection-title">
              Where Users Stand on Trending Policies
            </h3>
            <PolicySupportChart policies={trendingData.policies} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default TrendingTopics;
